import { render, staticRenderFns } from "./ShippingMethodsInputs.vue?vue&type=template&id=86a84228&"
import script from "./ShippingMethodsInputs.vue?vue&type=script&lang=ts&"
export * from "./ShippingMethodsInputs.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports